(() => {
  const SELECTOR = '.jm-media-grid__container';
  const LOCK_PX = 8;

  /** @type {number | null} */
  let startX = null;
  /** @type {number | null} */
  let startY = null;
  /** @type {'x' | 'y' | null} */
  let axis = null;
  /** @type {boolean} */
  let fromStrip = false;

  document.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.touches[0];
      const target = event.target;
      fromStrip = target instanceof Element && Boolean(target.closest(SELECTOR));
      axis = null;

      if (!fromStrip || !touch) {
        startX = null;
        startY = null;
        return;
      }

      startX = touch.clientX;
      startY = touch.clientY;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!fromStrip || startX == null || startY == null) return;

      const touch = event.touches[0];
      if (!touch) return;

      if (axis == null) {
        const dx = Math.abs(touch.clientX - startX);
        const dy = Math.abs(touch.clientY - startY);
        if (dx < LOCK_PX && dy < LOCK_PX) return;
        axis = dy > dx ? 'y' : 'x';
      }

      if (axis === 'y') {
        event.stopImmediatePropagation();
      }
    },
    { capture: true, passive: true }
  );

  const reset = () => {
    fromStrip = false;
    startX = null;
    startY = null;
    axis = null;
  };

  document.addEventListener('touchend', reset, { capture: true, passive: true });
  document.addEventListener('touchcancel', reset, { capture: true, passive: true });
})();
